<template>
    <div>
        <DesktopHistoryClass v-if="!isMobile" />
        <MobileHistoryClass v-else />
    </div>
</template>

<script>
import DesktopHistoryClass from '@/components/HistoryClass/Desktop/HistoryClass'
import MobileHistoryClass from '@/components/HistoryClass/Mobile/HistoryClass'
export default {
  components: {
    DesktopHistoryClass,
    MobileHistoryClass
  },
  data() {
    return{
      isMobile: false
    }
  },
  methods: {
      handleView() {
          this.isMobile = screen.width <= 990
      }
  },
  beforeMount() {
    this.handleView()
    this.$gtag.pageview(this.$route)
  }
}
</script>